<template>

    <div class="col">
      <div class="content-i">
        <div class="content-box pt-0">
          <h5 class="form-header">
           Avaliacoes
          </h5>
          <div class="row">
            <div class="col">
              <div class="element-box">
                <div class="row">
                  <div class="col">
                    <div class="label">
                      Atendimentos
                    </div>
                    <div class="element-box-tp">
                      <div class="table-responsive">
                        <table class="table table-padded">
                          <thead>
                            <tr>
                              <th>
                                ID Atendimento
                              </th>
                              <th>
                                Descrição atendimento
                              </th>
                              <th class="text-center">
                                Data
                              </th>
                              <th>
                                Avaliação
                              </th>
                              <th>
                                
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="depoimento in depoimentos"
                              :key="depoimento._id">
                              <td>
                                <div class="user-with-avatar">
                                  <img alt="" src="img/avatar1.jpg"><span>{{depoimento.pedido.codigo}}</span>
                                </div>
                              </td>
                              <td>
                                <div class="smaller lighter">
                                  {{depoimento.pedido.tipoPedido}} {{depoimento.pedido.consulta ? depoimento.pedido.consulta.especialidade.nome : ''}}
                                </div>
                              </td>
                              <td>
                                <span>{{getDataFormatada(depoimento.pedido.createdAt)}}</span>
                              </td>

                              <td class="nowrap smaller lighter">
                                <span>
                                  <rate v-if="depoimento.nota" disabled="true" v-model="depoimento.nota" :length="5"></rate>
                                  <small v-else>(Sem Avaliação)</small>
                                </span>
                              </td>
                              <td class="row-actions">
                                <button class="mr-2 mb-2 btn btn-outline-primary" @click="showAvaliacao(depoimento)" type="button"><i class="os-icon os-icon-grid-10"></i> Ver Avaliação</button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div aria-hidden="true" class="onboarding-modal modal fade animated" id="onboardingWideFormModal" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span class="os-icon os-icon-close"></span></button>
          <div class="onboarding-content with-gradient">
              <h4 class="onboarding-title">
                Avalie o seu atendimento
              </h4>
              
              <form>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="">Nota:</label>
                      <rate v-if="depoimento.nota" disabled="true" v-model="depoimento.nota" :length="5"></rate>
                      <small v-else>(Sem Avaliação)</small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="">Comentário</label>
                      <textarea disabled v-model="depoimento.descricao" class="form-control" name="basic" placeholder="Como foi seu atendimento?">
                      </textarea>
                    </div>
                  </div>
                  
                </div>
                
              </form>
            </div>
            <div class="modal-footer">
            <button class="btn btn-outline-primary" data-dismiss="modal" type="button"> Fechar</button>
          </div>
        </div>
      </div>
    </div>
    </div>
    
</template>
<script>
import * as axios from 'axios'
import moment from 'moment'

export default {
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  data () {
    return {
      depoimentos: [],
      depoimento: {}
    }
  },
  mounted () {
    moment.locale('pt-br')
    axios.get('/depoimentos?cliente=' + this.user.id + '&populate=pedido')
      .then(response => {
        this.depoimentos = response.data
      })
  },
  methods: {
    getDataFormatada (date) {
      if (!date) {
        return ''
      }
      return moment(date).format('DD/MM/YYYY')
    },
    showAvaliacao (depoimento) {
      this.depoimento = depoimento
      window.jQuery('#onboardingWideFormModal').modal('show')
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/pages/dashboard-cliente/AvaliacoesCliente.vue